<div class="auth-wrapper">
  <router-outlet></router-outlet>
</div>
